
<section class="container-fluid bg-light-dark pt-5 pb-4">
  <h1 class="my-4 text-center light-dark-color" data-cy="home-faq-title">Ficou com alguma dúvida? </h1>
  <section class="my-4 d-flex justify-content-center">
    <app-asks-expansion-panel class="asks"></app-asks-expansion-panel>
  </section>

  <p class="fs-4 text-muted text-center" data-cy="home-faq-help">
    Você tem alguma dúvida que não foi respondida aqui?
    <b><a class="primary-color" href="/central-de-ajuda" target="_blank" data-cy="home-faq-redirect-link">Acesse nossa central de ajuda!</a></b>
  </p>

</section>
